import { DestroyRef } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { storageKeys } from '@app/config';
import { BannerService } from '@app/core';
import { AppSelectors } from '@app/store';
import { AppState } from '@app/store/app.state';
import { Store } from '@ngrx/store';
import { uniq } from 'lodash';
import { LocalStorageService } from 'ngx-webstorage';
import { catchError, combineLatest, distinctUntilChanged, filter, map, of, switchMap } from 'rxjs';

export function loadBanners(store: Store, bannerService: BannerService, destroyRef: DestroyRef) {
  return store.select(AppSelectors.appFeature).pipe(
    takeUntilDestroyed(destroyRef),
    filter(({ usuario_ativo, show_tour }) => !!usuario_ativo && !!usuario_ativo.entidade_id && !show_tour),
    distinctUntilChanged(compare),
    map((store) => ({
      entidade_id: store.usuario_ativo.entidade_id,
      funcao_padrao: store.funcao_padrao,
      escola_externa: store.usuario_ativo.escola_externa,
      pais_id: store.usuario_ativo.pais_id,
      nivel_id: store.usuario_ativo.nivel_id,
      responsavel_legal: store.usuario_ativo.tipoResponsavel === 'L' ? 'L' : null,
      user_id: store.usuario_ativo.usuario_id,
    })),
    switchMap((params) =>
      combineLatest({
        userId: of(params.user_id),
        banners: bannerService.show(params).pipe(
          catchError(() => of({ ret: 0, data: [] })),
          map((res) => (res.ret === 1 ? res.banner : [])),
        ),
      }),
    ),
  );
}

export function updateStorageBannersViewed(_localStorageService: LocalStorageService, userId: number, banners: any[]) {
  _localStorageService.store(storageKeys.BANNERS_VIEWED, {
    ...(_localStorageService.retrieve(storageKeys.BANNERS_VIEWED) || {}),
    [userId]: uniq([
      ...(_localStorageService.retrieve(storageKeys.BANNERS_VIEWED)?.[userId] || []),
      ...banners.map((b: any) => b.id),
    ]),
  });
}

function compare(previous: AppState, current: AppState) {
  const fn = previous.funcao_padrao === current.funcao_padrao;
  const userId = previous.usuario_id === current.usuario_id;
  const entityId = previous.usuario_ativo?.entidade_id === current.usuario_ativo?.entidade_id;
  return fn && userId && entityId;
}
